import _ from 'lodash'

export default function getCurrentGroupJsonConfig({ previewGroup, groupsConfig, gameConfigResource }) {
  const gameDifficultyList = _.get(gameConfigResource, 'gameDifficultyList') || []
  const currentPreviewGroupConfig = groupsConfig.find(item => item.name === previewGroup)
  const currentPreviewGroupGameConfig = _.get(currentPreviewGroupConfig, 'game_config.data') || {}
  const currentGameDifficulty = (gameDifficultyList.find(item => item.is_default) || {}).data
  const jsonConfig = {
    i18n: _.get(currentPreviewGroupConfig, 'i18n.data'),
    ...currentPreviewGroupGameConfig,
    gameConfig: {
      ...currentPreviewGroupGameConfig.gameConfig,
      // 使用当前难度的配置
      ...currentGameDifficulty
    }
  }
  return _.cloneDeep(jsonConfig)
}
